import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";
import type { Customer } from "~/types/api";

const fetchCustomers = async (): Promise<Customer[]> => {
  const response = await configurationApi.client.GET("/api/Customer");

  if (response?.error) {
    const error = getErrorMessage(response.error, "Failed to fetch customers");
    throw new Error(error);
  }
  if (response?.response?.status < 200 || response?.response?.status > 299) {
    throw new Error("Unexpected response status: " + response.response.status);
  }

  return response.data || [];
};

export const useCustomersQuery = (
  options?: Omit<UseQueryOptions<Customer[], Error>, "queryKey" | "queryFn">
) => {
  return useQuery<Customer[], Error>({
    queryKey: configurationApi.queryOptions("get", "/api/Customer").queryKey,
    queryFn: () => fetchCustomers(),
    retry: 1,
    meta: {
      errorTitle: "Failed to load customers",
    },
    ...options,
  });
};
